import $ from "jquery";

$(document).on('turbolinks:before-cache', function () {
    // $('img.turbolink-image').remove();
});